import { AuthProvider, SignInPage } from "@toolpad/core";
import React from "react";
import { signInUser } from "../service/CognitoService";
import { useNavigate } from "react-router";
import { PATHS } from "../routing/paths";

export default function SignIn() {
  const navigate = useNavigate();
  const providers: AuthProvider[] = [
    { id: "credentials", name: "Benutzername & Passwort" },
  ];

  // signIn führt deinen Cognito-Login-Flow aus
  async function signIn(
    provider: AuthProvider,
    formData?: FormData,
  ): Promise<{ error?: string }> {
    const username = formData?.get("email") as string;
    const password = formData?.get("password") as string;
    try {
      await signInUser(username, password);
      navigate(PATHS.dashboard, { replace: true });
      return {};
    } catch (err: any) {
      return { error: err.message || JSON.stringify(err) };
    }
  }

  return (
    <SignInPage
      providers={providers}
      signIn={signIn}
      slots={{ rememberMe: () => null }}
      slotProps={{
        emailField: {
          label: "Benutzername",
          placeholder: "Benutzername",
          type: "text",
        },
        passwordField: { label: "Passwort" },
        submitButton: { children: "Anmelden" },
      }}
      localeText={{
        signInTitle: "Terminchat Administration App",
        signInSubtitle: "",
        signInRememberMe: "Angemeldet bleiben",
        email: "Benutzername",
        password: "Passwort",
        providerSignInTitle: (provider) => "Anmelden",
      }}
    />
  );
}
